module.exports = __webpack_public_path__ + "img/hr-fluid-wagon-shadow-5.151fdbe4.png";